import type { ProactiveDraftsStore } from './schema/ProactiveDraftsStore';
import type { ProactiveDraftsState } from './schema/ProactiveDraftsState';
import { createStore } from 'owa-satcheljs';

export const getProactiveDraftsStore: () => ProactiveDraftsStore =
    createStore<ProactiveDraftsStore>('proactiveDrafts', {
        proactiveDraftsListMap: new Map<string, ProactiveDraftsState>(),
        currentTelemetrySession: undefined,
    });
